import { Table, Button } from 'antd';
import styled, { css } from 'styled-components';
import BaseWidgetActionComponent from '../components/WidgetActionComponent';
import BaseDropdown from '../../../components/Dropdown';
import BaseTooltip from '../components/Tooltip';

export const TransactionDetalisPanel = styled.div`
  background: #fff;
  border-radius: 5px;
  margin-bottom: 24px;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.25);
  padding: 8px;

  .ant-radio-button-wrapper,
  .ant-picker,
  .ant-tabs,
  .ant-picker-input > input {
    font-size: 13px;
  }
  .ant-collapse-header {
    display: flex;
    align-items: center;
  }

  .ant-table-wrapper {
    overflow-x: auto;
  }

  .ant-table-content {
    overflow-x: auto;
  }
  .ant-table-thead {
    tr {
      .ant-table-cell {
        padding: 0.5rem;
        border-top: 1px solid #d5dee7;
        border-bottom: 1px solid #d5dee7;
        border-left: 1px solid #d5dee7;
        background: #eef4fa;
        vertical-align: top;
        font-size: 10px;
        font-weight: 500;
        font-style: normal;
        line-height: 12px;
        color: #556069;
        white-space: normal !important;
        word-break: break-word;
        &:last-of-type {
          border-right: 1px solid #d5dee7;
        }
      }
    }
  }
  .ant-table-tbody {
    tr {
      .ant-table-cell {
        padding: 0.75rem 0.5rem;
        font-style: normal;
        font-weight: normal;
        font-size: 11px;
        line-height: 12px;
        color: #556069;
        white-space: normal !important;
        word-break: break-word;
        strong {
          font-weight: 500;
        }
      }

      &:last-of-type {
        td {
          border-bottom: 1px solid #d5dee7;
        }
      }
    }
  }
  .ant-pagination {
    .ant-pagination-item {
      color: #31394d;
      border-radius: 4px;
    }
    .ant-pagination-item-active {
      color: #21b4bd;
      border-color: #21b4bd;
    }

    .ant-pagination-total-text {
      color: #b8bec5;
      line-height: 2rem;
    }

    .ant-pagination-item-link {
      border-radius: 4px;
    }
    .anticon {
      vertical-align: text-top;
    }
  }
`;

export const DownloadCSVWrapper = styled.div`
  float: right;
  margin-right: 16px;
`;

export const TransactionDetalisPanelHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const TransactionDetalisPanelTitle = styled.div`
  font-size: 16px;
  line-height: 19px;
  font-weight: 500;
  padding: 16px;
`;

export const TransactionDetailsTable = styled(Table)`
  .ant-table .ant-table-container table .ant-table-tbody .ant-table-cell {
    font-size: 10px;
  }

  .ant-table-container {
    overflow-x: auto;
  }

  .ant-table {
    width: 100%;
    table-layout: auto;
  }

  th.ant-table-cell {
    white-space: normal !important;
    word-break: break-word;
    vertical-align: top;
    min-width: 60px;
    max-width: 85px;
  }

  td.ant-table-cell {
    white-space: normal !important;
    word-break: break-word;
    min-width: 60px;
    max-width: 85px;
  }
`;

export const WidgetActionComponent = styled(BaseWidgetActionComponent)`
  margin-top: 0;
  margin-bottom: 0;
  width: auto;
`;

export const Container = styled.div`
  display: flex;
  align-items: flex-end;
`;

export const ActionItem = styled.div`
  margin-right: 40px;

  &:last-child {
    margin-right: 0;
  }
`;

export const ActionLabel = styled.div`
  font-size: 12px;
  line-height: 20px;
  color: #748aa1;
  font-weight: 400;
  margin-bottom: 5px;
`;

export const Dropdown = styled(BaseDropdown)`
  /* FIN-12131: fill the Advanced-Filter field (no layout shift on select) and make
     the wrapper the positioning context for the absolute menu. The menu width is
     bound to the field by passing width="100%" at the call site (BaseDropdown
     applies it inline to control + menu), so long Variant options wrap WITHIN the
     panel instead of spilling past its right border. */
  width: 100%;
  position: relative;

  & > div:first-child {
    border-radius: 4px;
    border-color: #d0d7e3;
    height: 32px;
    line-height: 30px;

    & > i {
      line-height: 30px;
    }
  }
`;

export const Tooltip = styled(BaseTooltip)`
  display: inline-block;
`;

export const SearchBarContainer = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  gap: 8px;

  .ant-select-selector,
  .ant-input {
    font-size: 13px;
  }
`;

export const FilterRow = styled.div`
  width: 100%;
  display: flex;
  margin-top: 4px;
  margin-bottom: 8px;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-end;
`;

export const AmountRangeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .ant-input-number {
    width: 100px;
    font-size: 13px;
  }
`;

export const SearchRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 16px 12px;
`;

export const AdvancedFiltersButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  font-size: 13px;

  &:hover,
  &:focus {
    border-color: #1890ff !important;
    color: #1890ff !important;
  }

  ${({ $active }) =>
    $active &&
    css`
      border-color: #1890ff !important;
      color: #1890ff !important;
    `}
`;

export const AdvancedFiltersPanelWrapper = styled.div`
  background: #fff;
  border: 1px solid #e8ecf1;
  border-radius: 4px;
  padding: 16px;
  /* FIN-13722: fixed width, not min-width. The Popover shrink-wraps its content,
     and a flex row's intrinsic width ignores the fields' flex-basis 0, so a long
     selected Variant (nowrap label) widened the whole panel on reopen. A definite
     width lets the fields shrink and the label ellipsize instead. */
  width: 744px;
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
`;

export const AdvancedFiltersPanelHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const AdvancedFiltersPanelTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #31394d;
`;

export const AdvancedFiltersFieldsRow = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 16px;
  align-items: flex-start;
`;

export const AdvancedFilterField = styled.div`
  /* FIN-12131: equal, stable field widths. flex-basis 0 + min-width 0 stop a
     field from growing to fit a long selected value (e.g. a long Variant name),
     which previously shifted every other dropdown in the row. Long selected
     values ellipsize within the field instead of expanding it. */
  flex: 1 1 0;
  min-width: 0;

  .ant-select {
    width: 100%;
  }
  .ant-select-selection-item {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const AdvancedFiltersActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;

  .ant-btn-primary:not(:disabled) {
    background-color: #1890ff;
    border-color: #1890ff;
    color: #fff;

    &:hover,
    &:focus {
      background-color: #40a9ff;
      border-color: #40a9ff;
      color: #fff;
    }
  }

  .ant-btn-default:not(:disabled) {
    &:hover,
    &:focus {
      color: #1890ff;
      border-color: #1890ff;
    }
  }
`;

export const MainFiltersRow = styled.div`
  display: flex;
  align-items: flex-end;
  padding: 0px 16px 12px;
  margin-bottom: 4px;
`;

export const DownloadButtonWrapper = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;

  .ant-btn:not(:disabled):hover,
  .ant-btn:not(:disabled):focus,
  .ant-btn:not(:disabled):active {
    color: #1890ff;
    border-color: #1890ff;
  }
`;

export const TableContainer = styled.div`
  margin: 6px 16px 24px;
`;
